import { render } from "./AnnualReviews.vue?vue&type=template&id=6263847b"
import script from "./AnnualReviews.vue?vue&type=script&lang=js"
export * from "./AnnualReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__